module.exports = __webpack_public_path__ + "img/emoji15.png";